import { useState } from 'react';
import { homeSEOContent } from '@/mocks/seoContent';

export default function FAQSection() {
  const { faqs } = homeSEOContent;
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  const toggle = (idx: number) => {
    setOpenIdx(openIdx === idx ? null : idx);
  };

  return (
    <section id="faq" className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-primary-500 uppercase tracking-widest mb-3">FAQ</p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Frequently Asked Questions
          </h2>
          <p className="mt-3 text-sm text-foreground-500">
            Everything you need to know about the CSSBuy Spreadsheet and how to get the most out of it.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-background-100/80 transition-colors"
              >
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <span className={`flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 transition-transform duration-300 ${openIdx === idx ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-sm"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'max-h-[600px] pb-6 px-6' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-sm text-foreground-500 mb-4">Still have questions? Visit the main site for more information.</p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            Go to Kaspreadsheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}